import * as React from 'react';
import logo from '../assets/logo-conecta-venda.png';

type Props = {
    text: string
};
export const Header = (props: Props) => {
    const {text} = props;

    return (
        <header className={'w-full'}>
            <div className="flex w-full py-4 px-12 rounded-full justify-between bg-background border border-solid border-primary md:px-6">
                <div className="w-36">
                    <img
                        src={logo}
                        width={153}
                        height={30}
                        className="w-full h-auto"
                        alt={"Conecta Venda"}
                    />
                </div>
                <div className="text-primary font-bold text-center flex items-center rounded-full border border-solid border-primary px-8 md:px-4">
                    <h6>
                        {text}
                    </h6>
                </div>
            </div>
        </header>
    );
};